import React from 'react';
import { Modal } from "react-bootstrap";
import 'components/modals/_customModal.scss';

function ConfirmModal({
  show,
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
  variant = "primary" // primary, danger, warning
}) {
  const getButtonClass = () => {
    // Use primary-btn for all confirm buttons to match existing modal pattern
    let baseClass = "primary-btn";
    
    // Add variant-specific classes
    if (variant === "danger") {
      baseClass += " danger-variant";
    } else if (variant === "warning") {
      baseClass += " warning-variant";
    }
    
    return baseClass;
  };


  return (
    <Modal
      show={show}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <button 
          className="primary-btn secondary" 
          onClick={onCancel}
          disabled={loading}
        >
          {cancelText}
        </button>
        <button 
          className={getButtonClass()} 
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? 'Processing...' : confirmText}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmModal;
